import React from 'react'

import { theme } from '../../constants/theme'

import { Tag } from './Tag'

export const DraftIcon = () => (
  <Tag label="draft" color={theme.colors.warningOrange} filled />
)
